import {InGameChallengesController_ClaimTicketResponse} from "../api/api.service";
import {IUserTicket} from "../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {ServiceBase} from "../ServiceBase";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {delay} from "../../../utils/delay";
import {TimeSpan} from "@sparkware/app-utils";
import {InGamePromotionPrizes} from "./in-game-promotion-prizes";
import {IInGameTicketPrize} from "./prize/abstract/in-game-ticket-prize-types";

type ClaimTicketResponseData = InGameChallengesController_ClaimTicketResponse["data"];
interface IClaimTicketResponseData extends ClaimTicketResponseData {
    prize: IInGameTicketPrize;
}

export class InGameTicketModel extends ServiceBase {
    private prizesObj: InGamePromotionPrizes;
    private actualPrizePromise: Promise<IClaimTicketResponseData> | null = null;
    public claimed = false;

    constructor(private _ticketData: IUserTicket, services: IServiceFactoryExtended) {
        super(services);

        this.prizesObj = this.services.inGameTicket.promotionPrizesProvider.getPrizesWrapper(this._ticketData.promotionId);

        this.reaction(() => Boolean(this.isActive), (isActive) => {
            if (!isActive) {
                this.services.inGameTicket.removeTicket(this.id);
            }
        })
    }

    get id(): number {
        return this._ticketData.ticketId;
    }

    get expirationDate(): Date {
        return new Date(this._ticketData.expirationDate);
    }

    private _isExpired = this.checkExpiration();
    get isExpired(): boolean {
        if (this._isExpired) {
            return this._isExpired;
        }
        this._isExpired = this.checkExpiration();
        return this._isExpired;
    }

    get isActive(): boolean {
        return !this.isExpired;
    }

    async getPrizes() {
        return this.prizesObj.getPrizes();
    }

    resetGetPrizesFailedPromise() {
        return this.prizesObj.resetGetPrizesFailedPromise();
    }


    private checkExpiration() {
        const currentDate = this.services.time.now();
        const expirationDate = new Date(this._ticketData.expirationDate).getTime();

        return currentDate > expirationDate
    }

    public async claimTicket(retry: boolean = false, retryInterval: TimeSpan = TimeSpan.fromMilliseconds(1000)): Promise<IClaimTicketResponseData> {
        try {
            let response = await this.services.api.inGameChallengesController.claimTicket({
                ticketId: this._ticketData.ticketId
            });
            if (response.hasError) {
                const errorMsg = `InGame Challenge: ticket prizes fetch errored: ` + JSON.stringify({
                    errorCode: response.errorCode,
                    errorDescription: response.errorDescription,
                    errorDetails: response.errorDetails
                });
                this.services.logger.debug(errorMsg);
                throw new Error(errorMsg);
            } else {
                this.claimed = true;
                const responseData = {
                    ...response.data,
                    prize: this.services.inGameTicket.ticketPrizeFactory.createInGameTicketPrize(response.data.prize)
                }
                return responseData;
            }
        } catch (e) {
            if (retry) {
                await delay(retryInterval);
                return await this.claimTicket();
            } else {
                throw e;
            }
        }
    }
}
